import { getSubscriptionDispatches } from "../selectors/getSubscriptionDispatches.js";
import { getSubscriptionSeriesDefinition } from "../selectors/getSubscriptionSeriesDefinition.js";
import { getSubscriptionType } from "../selectors/getSubscriptionType.js";
import { getSubscriptionVariantTerms } from "../selectors/getSubscriptionVariantTerms.js";
import { getSubscriptionVariantGifts } from "../selectors/getSubscriptionVariantGifts.js";
import { getSubscriptionPlanPricing, getSubscriptionVariantPlan, } from "../selectors/getSubscriptionVariantPlans.js";
import { isSubscriptionShapeBookClub, isSubscriptionShapeSeries, isSubscriptionShapeSubscription, } from "../../subscription-plan/selectors/isSubscriptionShape.js";
import { getSubscriptionName } from "../selectors/getSubscriptionName.js";
import { getSubscriptionConcept } from "../selectors/getSubscriptionConcept.js";
import { getSubscriptionVariantFreightOptions } from "../selectors/getSubscriptionFreightOptions.js";
import { getSubscriptionVariantTermsConditions } from "../selectors/getSubscriptionVariantTermsConditions.js";
import { getBookClubTermsConditions } from "../selectors/getBookClubTermsConditions.js";
import { getSubscriptionVariantProductSelector } from "../selectors/getSubscriptionVariantProductSelector.js";
import { fetchSubscriptionItem } from "./fetchSubscriptionItem.js";
import { getDefaultPlanPeriod } from "../selectors/getSubscriptionDefaultPeriod.js";
import { getSubscriptionCampaignBooks } from "../selectors/getSubscriptionCampaignBooks.js";
import { getIsChildClub } from "../selectors/getIsChildClub.js";
import { getSubscriptionClubCode } from "../selectors/getSubscriptionClubCode.js";
import { getSubscriptionVariantEndingInvoice } from "../selectors/getSubscriptionVariantEndingInvoice.js";
import { getSubscriptionProductTerms } from "../selectors/getSubscriptionProductTerms.js";
import { getSubscriptionShopTopicPaths, getSubscriptionShopTopics, } from "../selectors/getSubscriptionTopics.js";
import { getSubscriptionVariantBenefits } from "../selectors/getSubscriptionVariantBenefits.js";
import { getNextClubName } from "../selectors/getNextClubName.js";
import { getSubscriptionClubName } from "../selectors/getSubscriptionClubName.js";
import { getBookClubCancelHref } from "../selectors/getBookClubCancelHref.js";
import { getBookClubMemberOffers } from "../selectors/getBookClubMemberOffers.js";
export const getSubscriptionProduct = async ({ sku }, { client }) => {
    const subscription = await fetchSubscriptionItem(sku, { client });
    const pricing = getSubscriptionPlanPricing(subscription);
    const type = getSubscriptionType(subscription);
    const topics = getSubscriptionShopTopics(subscription);
    const shopTopicPaths = getSubscriptionShopTopicPaths(subscription);
    const isSeries = isSubscriptionShapeSeries(type);
    const isBookSubscription = isSubscriptionShapeSubscription(type);
    const isBookClub = isSubscriptionShapeBookClub(type);
    const subscriptionProduct = {
        type,
        sku: subscription.sku,
        name: subscription.product.name,
        externalName: getSubscriptionName(subscription),
        variantName: subscription.name,
        gifts: getSubscriptionVariantGifts(subscription),
        dispatches: isBookSubscription
            ? getSubscriptionDispatches(subscription)
            : isBookClub
                ? getSubscriptionDispatches(subscription)
                : undefined,
        series: isSeries
            ? getSubscriptionSeriesDefinition(subscription)
            : undefined,
        terms: isBookClub
            ? getSubscriptionProductTerms(subscription)
            : getSubscriptionVariantTerms(subscription),
        plan: getSubscriptionVariantPlan(subscription),
        period: getDefaultPlanPeriod(subscription),
        freight: getSubscriptionVariantFreightOptions(subscription),
        termsConditions: getSubscriptionVariantTermsConditions(subscription),
        bookclubTermsConditions: isBookClub
            ? getBookClubTermsConditions(subscription)
            : undefined,
        productSelector: getSubscriptionVariantProductSelector(subscription),
        concept: !isBookClub ? getSubscriptionConcept(subscription) : undefined,
        clubCode: isBookClub ? getSubscriptionClubCode(subscription) : undefined,
        clubName: isBookClub ? getSubscriptionClubName(subscription) : undefined,
        nextClubName: isBookClub ? getNextClubName(subscription) : undefined,
        endingInvoice: isBookClub
            ? getSubscriptionVariantEndingInvoice(subscription)
            : undefined,
        campaignBooks: getSubscriptionCampaignBooks(subscription),
        benefits: isBookClub ? getSubscriptionVariantBenefits(subscription) : [],
        cancelHref: isBookClub ? getBookClubCancelHref(subscription) : undefined,
        memberOffers: isBookClub
            ? getBookClubMemberOffers(subscription)
            : undefined,
        productId: subscription.product.id,
        topics,
        shopTopicPaths,
        ...pricing,
    };
    const subscriptionProductUtils = {
        // Subscription utils
        isSeries,
        isBookSubscription,
        isBookClub,
        isDiscountedFirstBook: pricing.initialPrice?.price === 0 || false,
        isChildClub: isBookClub ? getIsChildClub(subscription) : false,
    };
    return {
        ...subscriptionProduct,
        ...subscriptionProductUtils,
    };
};
